module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+aWNvbi10YXNrcy1wYXVzZTwvdGl0bGU+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOCA4aDIwdjIwSDh6Ii8+PHBhdGggZD0iTTEzLjk5NCAxMi4wMDFoMi4wMDR2MTJoLTIuMDA0di0xMnptNiAwaDIuMDA0djEyaC0yLjAwNHYtMTJ6IiBmaWxsPSIjNDg0ODQ4Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctype/icon-suspend.svg
// module id = 6lG3
// module chunks = 25